import { createSelector } from '@reduxjs/toolkit'

export const notificationSelector = state => state.notificationReducer

export const getCurrentNotification = createSelector(
  notificationSelector,
  notification => notification.notifications[0] || {}
)
